"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ALL_PAYABLE_PERMISSIONS = exports.PayablePermissions = void 0;
/**
 * Permission string catalog for the Accounts Payable bounded context
 * (Stage 13, Milestone 2 Part 2). Format `<module>:<action>`, same
 * convention as `receivable.permissions.ts`. Vendor Master CRUD uses
 * `MasterDataPermissions.VENDOR_MASTER_*` instead (mirrors how
 * `PayerMaster` lives under `MasterDataPermissions`, not
 * `FinancialPermissions` — Vendor Master is master-data, this catalog
 * is the AP workflow surface on top of it).
 */
exports.PayablePermissions = {
    /** createInvoice. */
    PAYABLE_INVOICE_CREATE: 'payable:invoice:create',
    /** writeOff — OPEN/PARTIALLY_PAID only. */
    PAYABLE_INVOICE_WRITE_OFF: 'payable:invoice:write-off',
    /** cancelInvoice — OPEN with zero allocations only. */
    PAYABLE_INVOICE_CANCEL: 'payable:invoice:cancel',
    /** createPayment (FinVendorPayment). */
    PAYABLE_PAYMENT_CREATE: 'payable:payment:create',
    /** allocate, allocateAutomatically, resolveOverpayment, convertOverpaymentToAdvance. */
    PAYABLE_ALLOCATION_MANAGE: 'payable:allocation:manage',
    /** Vendor advance account open/credit/debit/settle/close. */
    PAYABLE_ADVANCE_MANAGE: 'payable:advance:manage',
    /** Invoice listing/read, Vendor Ledger/Statement, Outstanding, Ageing, GL drill-down. */
    PAYABLE_LEDGER_READ: 'payable:ledger:read',
    /** issueCreditNote. */
    PAYABLE_CREDIT_NOTE_ISSUE: 'payable:credit-note:issue',
    /** issueDebitNote. */
    PAYABLE_DEBIT_NOTE_ISSUE: 'payable:debit-note:issue',
    /** create/cancel a Payment Advice. */
    PAYABLE_PAYMENT_ADVICE_CREATE: 'payable:payment-advice:create',
    /** submit/approve/reject/fulfil a Payment Advice. */
    PAYABLE_PAYMENT_ADVICE_APPROVE: 'payable:payment-advice:approve',
};
/** Every Payable permission, flattened — used to seed the `permissions` table. */
exports.ALL_PAYABLE_PERMISSIONS = Object.values(exports.PayablePermissions);
//# sourceMappingURL=payable.permissions.js.map